const language = (state) => state.language;
const env = (state) => state.env;
const accessTokenKey = (state) => state.ACCESS_TOKEN_KEY;
const homepageInfo = (state) => state.homepageInfo;
const portalUrl = (state) => state.homepageInfo.availableSvc ? state.homepageInfo.availableSvc.find((svc) => (svc.svcId === 'portal')).svcUrl : null;

export default {
  language,
  accessTokenKey,
  env,
  homepageInfo,
  portalUrl
};



// WEBPACK FOOTER //
// ./src/store/modules/common/getters.js